export type { CopilotKitCSSProperties } from "./css";
export type { CopilotChatSuggestion } from "./suggestions";
